import moment from "moment";

export function getStartOfCurrentDay(timezone: string): number {
  return moment.tz(timezone)
    .set('hours', 0)
    .set('minutes', 0)
    .set('seconds', 0)
    .set('milliseconds', 0)
    .valueOf()
}